import type { FC } from "react";
import type { EmailDetailsModel } from "../../../models/EmailDetailsModel";
import { Row } from "react-grid-system";
import { HorizontalSpacer } from "../../atoms/Spacers";
import Body from "../../atoms/typography/Body";
import { theme } from "../../../theme";
import { EmailBody } from "../documentHandler/UploadUnitNotificationsComponents";
import dayjs from "dayjs";
import Subheading from "../../atoms/typography/Subheading";

interface Props {
  emailContent: EmailDetailsModel;
}

const EmailDisplayModalContent: FC<Props> = ({ emailContent }) => {
  return (
    <div>
      <Row justify="center">
        <Subheading>{emailContent?.subject}</Subheading>
        <HorizontalSpacer spacing={1} />
        <Body color={theme.colors.textSecondary}>
          {emailContent?.sentFromEmail} | {emailContent?.recipients.join(", ")}{" "}
          | {dayjs(emailContent?.receivedDate).format("YYYY-MM-DD HH:mm")}
        </Body>
        <HorizontalSpacer spacing={2} />
      </Row>
      {emailContent?.rawBody && (
        <Body>
          <EmailBody rawHtml={emailContent?.rawBody} />
        </Body>
      )}
    </div>
  );
};

export default EmailDisplayModalContent;
